// extracted by mini-css-extract-plugin
module.exports = {"testCoverWrapper":"testCover__testCoverWrapper___d104d"};